module.exports = __webpack_public_path__ + "static/media/wQ.4e4432a6.svg";